import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { AuditInvitationDetail } from '@/common';

type Body = {
  choice: 'confirm' | 'deny-statement' | 'deny-busy' | 'deny-conflict' | 'deny-other';
  reason?: string;
  lang?: string;
};

export const answerAuditInvitation = async ({
  id,
  data,
}: {
  id: string;
  data: Body;
}): Promise<AuditInvitationDetail> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-invitations/${id}/answer`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditInvitationDetail;
  return response;
};
